import { render, staticRenderFns } from "./Zero.vue?vue&type=template&id=45a92a56"
import script from "./Zero.vue?vue&type=script&lang=js"
export * from "./Zero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports